import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

export const fetchBusinessAccounts = createAsyncThunk(
  'businessAccounts/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.businessAccounts.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  accounts: [],
  currentAccount: null,
  loading: false,
  error: null,
};

const businessAccountsSlice = createSlice({
  name: 'businessAccounts',
  initialState,
  reducers: {
    setCurrentAccount: (state, action) => {
      state.currentAccount = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload.data || action.payload;
      });
  },
});

export const { setCurrentAccount, clearError } = businessAccountsSlice.actions;
export default businessAccountsSlice.reducer;

